import React from "react";
import { PieChart, Pie, Cell } from "recharts";

interface Props {
  data: Array<{
    id: string;
    titleKey: string;
    percentage: number;
    color: string;
  }>;
  width?: number;
}

const DonutChart: React.FC<Props> = ({ data, width = 120 }) => {
  const isEmpty = !data || data.every((entry) => entry.percentage === 0);
  const outerRadius = Math.round(width * 0.5) - 2;
  const innerRadius = Math.round(outerRadius * 0.43);

  return (
    <PieChart width={width} height={width}>
      {isEmpty ? (
        <Pie
          data={[{ percentage: 1 }]}
          dataKey="percentage"
          nameKey="title"
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          fill="#ffffff"
          isAnimationActive={false}
        >
          <Cell fill="#F5F5F5" />
        </Pie>
      ) : (
        <Pie
          data={data}
          dataKey="percentage"
          nameKey="title"
          cx="50%"
          cy="50%"
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          fill="#ffffff"
          isAnimationActive={true}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      )}
    </PieChart>
  );
};

export default DonutChart;
